import { useState } from 'react';
import { Checkbox } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
import CommonModal from 'PhishingManager/components/Modal';
import Alert from 'PhishingManager/components/Alert';

interface ReleaseCampaignModalProps {
    visible: boolean;
    onClose: () => void;
    onRelease: () => void;
    userCount?: number;
}

const ReleaseCampaignModal = ({
    visible,
    onClose,
    onRelease,
    userCount = 1500,
}: ReleaseCampaignModalProps) => {
    const [testEmailConfirmed, setTestEmailConfirmed] = useState(false);

    const handleClose = () => {
        onClose();
    };

    const handleRelease = () => {
        if (testEmailConfirmed) {
            onRelease();
        }
    };

    return (
        <CommonModal
            visible={visible}
            modalTitle="Release full campaign?"
            confirmText="Release full campaign"
            cancelText="Cancel"
            iconType={null}
            showConfirmBtn={true}
            confirmBtnDisabled={!testEmailConfirmed}
            onClose={handleClose}
            onConfirm={handleRelease}
            parentClass='pm-release-modal'
        >
            <div className='pm-release-modal-body'>
                <p className="pm-release-description">
                    This will send the phishing campaign to all
                    {userCount} selected users.
                    Once released, this action cannot be undone.
                </p>

                <div className="alert-section">
                    <Alert subtitle="Have you successfully received and reviewed the test email? Releasing the campaign without confirming the test may lead to delivery issues." />
                </div>

                <div className="pm-release-checkbox-row">
                    <Checkbox
                        checked={testEmailConfirmed}
                        onChange={(e) => setTestEmailConfirmed(e.target.checked)}
                    >
                        <span className="pm-release-checkbox-label">I received the test email</span>
                    </Checkbox>
                </div>
            </div>
        </CommonModal >
    );
};

export default ReleaseCampaignModal;